// test378
(378 && 0);
